import React from "react";
import { HorizRule, Img, Link } from "../core/pdf/types";
import { useContentState } from "./useContentState";
// import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { toMillimeters } from "../core/pdf/utils";
import { useDesigner } from "./useDesigner";
import { Icon } from "../core/ui/icons";
import { api } from "../api/api";

export function LinkEditor(props: {
	link: Link,
}) {
	const designer = useDesigner();

	const link = props.link;

	const elementContext = useElementContext(link);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	const style = designer.createStyle(props.link);

	const title = link.title ? link.title : "Link";

	let el;
	if (link.display === "button") {
		el = <button>{title}</button>;
	} else {
		el = <a href={link.url}>{title}</a>
	}

	return (
		<ElementContext.Provider value={elementContext}>
			<div
				className={"link content-element " + state.classes}
				data-key={link.id}
				id={state.elementID}
				tabIndex={0}
				style={style}
			>
				{el}
			</div>
		</ElementContext.Provider>
	);
}
